<div class="modal-header">
    <h4 class="modal-title">Confirmação</h4>
    <button type="button" class="btn-close float-end" aria-label="Close" (click)="cancelar()"></button>
</div>
<div class="modal-body">
    <p>{{ message }}</p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-rounded btn-danger" (click)="cancelar()">Não</button>
    <button type="button" class="btn btn-rounded btn-info" (click)="confirmar()">Sim</button>
</div>
